export const GET_ALL_FAQS_REQUEST_SENT = 'src/patientApp/Questions/GET_ALL_FAQS_REQUEST_SENT';
export const GET_ALL_FAQS_REQUEST_SUCCEED = 'src/patientApp/Questions/GET_ALL_FAQS_REQUEST_SUCCEED';
export const GET_ALL_FAQS_REQUEST_FAILED = 'src/patientApp/Questions/GET_ALL_FAQS_REQUEST_FAILED';
export const RESET_ALL_FAQS_METADATA = 'src/patientApp/Questions/RESET_ALL_FAQS_METADATA';
